// extracted by mini-css-extract-plugin
export var option = "_bd-0";
export var optionCard = "_bd-f";
export var optionContent = "_bd-g";
export var optionIcon = "_bd-i";
export var optionIconBox = "_bd-h";
export var optionLabel = "_bd-j";
export var optionPill = "_bd-m";
export var optionPillBadge = "_bd-p";
export var optionPillIcon = "_bd-n";
export var optionPillLabel = "_bd-o";
export var optionRadio = "_bd-k";
export var optionRadioInner = "_bd-l";
export var optionReveal = "_bd-2";
export var optionRevealDelay0 = "_bd-3";
export var optionRevealDelay1 = "_bd-4";
export var optionRevealDelay10 = "_bd-d";
export var optionRevealDelay11 = "_bd-e";
export var optionRevealDelay2 = "_bd-5";
export var optionRevealDelay3 = "_bd-6";
export var optionRevealDelay4 = "_bd-7";
export var optionRevealDelay5 = "_bd-8";
export var optionRevealDelay6 = "_bd-9";
export var optionRevealDelay7 = "_bd-a";
export var optionRevealDelay8 = "_bd-b";
export var optionRevealDelay9 = "_bd-c";
export var optionSelected = "_bd-1";